<template>
  <div>
    <van-cell-group title="发票信息" style="font-size: 18px;">
      <van-row gutter="20" type="flex" justify="center" style="margin-top: 20px;">
        <van-col span="6"><van-field label="户号" :value="huhao" v-model="huhao" /></van-col>
        <van-col span="6"><van-field label="发票时间" :value="ym" readonly @click="showTime" /></van-col>
      </van-row>
      <van-row gutter="20" type="flex" justify="center" style="margin-top: 20px;">
        <van-col span="6"><van-field label="验证码" :value="yzm" v-model="yzm" /></van-col>
        <van-col span="6"><img :src="src" class="img" @click="changeimg" /></van-col>
      </van-row>

      <!-- <div v-if="fpUrl!=''"><a :href="fpUrl" :download="name">点击下载</a></div> -->
    </van-cell-group>
    <van-cell-group title="发票下载" v-if="data.length != 0">
      <div v-for="item in data">
        发票文件:
        <a :href="item.fpUrl">点击下载</a>
        <hr />
      </div>
    </van-cell-group>
    <van-row gutter="20" type="flex" justify="center" style="margin-top: 20px;">
      <van-col span="6"><van-button type="info" size="large" @click="getFp()">查询</van-button></van-col>
      <van-col span="6"><van-button type="primary" size="large" @click="back()">返回</van-button></van-col>
    </van-row>

    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
    <van-overlay :show="jzshow" @click="jzshow = false"><van-loading size="24px" vertical color="#ffffff" style="margin-top: 18.75rem;">加载中...</van-loading></van-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      huhao: '',
      ym: '',
      src:  this.baseUrl + 'api/check_code/',
      yzm: '',
      fpUrl: '',
      show: false,
      jzshow: false,
      minDate: new Date(2016, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      data: []
    };
  },
  methods: {
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    back() {
      this.$router.back();
    },
    changeimg() {
      this.src = this.baseUrl + 'api/check_code/?temp=' + Math.random();
    },
    getFp() {
      this.fpUrl = '';
      this.jzshow = true;
      this.$axios({
        url: this.baseUrl + 'api/fpdownload/',
        method: 'post',
        data: { huhao: this.huhao, ym: this.ym, yzm: this.yzm, format: 'json' }
      })
        .then(res => {
          var backdata = res.data;
          this.jzshow = false;
          if (backdata == '') {
            this.$notify({ type: 'danger', message: '未查询到对应发票!' });
          } else if (backdata.code == 100) {
            this.$notify({ type: 'danger', message: '输入错误,请检查!' });
          } else if (backdata.code == 101) {
            this.$notify({ type: 'danger', message: '请输入正确验证码!' });
          } else {
            this.data = res.data;
          }
        })
        .catch(err => {
          this.jzshow = false;
          console.log(err);
        });
      this.changeimg();
    },
    down() {},
    showTime() {
      this.show = true;
    },
    confirm(value) {
      this.ym = this.dateFormat('YYYYmm', value);
      this.show = false;
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
      }
      return fmt;
    },
    cancel() {
      this.show = false;
    }
  },
  created() {
    // this.huhao = this.$route.params.huhao
  }
};
</script>

<style>
.van-cell-group__title {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue